import { GiCargoShip } from "react-icons/gi";
import React from "react";
import NavBtn from "../NavBtn";

const Shipments = (props) => {
  const {
    exactPath = "/dashboard/shipments",
    to = "/dashboard/shipments",
    partialPath = "/shipments",
    label = "Shipments",
  } = props;

  return (
    <NavBtn
      label={label}
      exactPath={exactPath}
      partialPath={partialPath}
      to={to}
      Icon={GiCargoShip}
    />
  );
};

export default Shipments;
